import { updateModel, getModel } from './Model'

export const selectClient = (client_id, skipReload = false) => {
	updateModel(model => {
		model.me.data.clients = model.me.data.clients.map(client => {
			if (client.client_id === client_id) client.active = !client.active
			return client
		})

		return model
	})
	
	if (!skipReload) {
		window.location.reload()
	}
}

export const getSelectedClients = () => {
	const Model = getModel()
	if (Model.me.data.clients.length === 0) return []
	return Model.me.data.clients.filter(client => client.active)
}

export const selectClientIfNonIsSelected = () => {
	const Model = getModel()

	if (getSelectedClients().length === 0 && Model.me.data.clients.length > 0) 
		selectClient(Model.me.data.clients[0].client_id, true)
}
